// extracted by mini-css-extract-plugin
export default {"grid":"TyreDetails__grid--DeXf7","th":"TyreDetails__th--LIVmX","td":"TyreDetails__td--Z51nz"};